import ElectionPage from './page/ElectionPage';
export default function App() {
  return <ElectionPage/>
}
